import React from 'react';
import { useTranslation } from 'react-i18next';

import { LineSeparator } from '@/components/LineSeparator';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

type P2pMaxEntryAmountExceededProps = {
    placedEntryAmount: number;
    creditedBack: number;
};

export const P2pMaxEntryAmountExceeded = ({ placedEntryAmount, creditedBack }: P2pMaxEntryAmountExceededProps) => {
    const { t } = useTranslation('p2p');

    return (
        <Box>
            <Text
                color={ds.colorToken.text.secondary}
                textAlign={'center'}
                variant="bodyMedium"
                paddingBottom={'s12'}
                paddingHorizontal={'s8'}
            >
                {t('leaderboard_groups_maxed_out_description', { placedEntryAmount, creditedBack })}
            </Text>
            <Box pt="s0">
                <Row py="s16" justifyContent="space-between">
                    <Text variant="bodyMedium">{t('placed_entry_amount')}</Text>
                    <Text variant="bodyMedium" color={ds.colorToken.text.primary}>
                        ${placedEntryAmount}
                    </Text>
                </Row>
                <LineSeparator style={common.hairlineHeight} />
                <Row py="s16" justifyContent="space-between">
                    <Text variant="bodyMedium">{t('credited_back')}</Text>
                    <Text variant="bodyMedium" color={ds.colorToken.text.primary}>
                        ${creditedBack}
                    </Text>
                </Row>
            </Box>
            <LineSeparator style={common.hairlineHeight} />
        </Box>
    );
};
